import { ref } from 'vue'

// Shared, module-level store for GET /api/services/booking-settings.
// Defaults match the previous inline defaults of the legacy modal so the capacity /
// advance-booking maths behaves identically when the API is unreachable.

const settings = ref({
    advanceBookingDays: 30,
    cancellationHours: 24,
    allowSameDayBooking: false,
    sameDayLeadTimeMinutes: 0
})

const isLoaded = ref(false)
const error = ref(null)
let inflight = null

const load = () => {
    if (isLoaded.value) return Promise.resolve(settings.value)
    if (inflight) return inflight

    inflight = (async () => {
        try {
            const response = await fetch('/api/services/booking-settings')
            if (!response.ok) throw new Error(`Booking settings API failed: ${response.status}`)
            const data = await response.json()
            if (data.success && data.data) {
                settings.value = data.data
                isLoaded.value = true
                error.value = null
            }
        } catch (err) {
            error.value = err
            console.warn('[BookingSettings]', err.message)
        } finally {
            inflight = null
        }
        return settings.value
    })()

    return inflight
}

export const useBookingSettings = () => ({ settings, isLoaded, error, load })
